import React  from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Breadcrumb from '../../components/Breadcrumb';
import CourseSidebarMain from './CourseSidebarMain';
import ScrollToTop from '../../components/ScrollTop';

const CourseSidebar = () => {

    return (
        <div className="courses-grid-page">
            <Header
                parentMenu='page'
            />

            <div className="react-wrapper">
                <div className="react-wrapper-inner">
                    <Breadcrumb
                        pageTitle="Aptitude Tests"
                    />

                    <CourseSidebarMain />

                    {/* scrolltop-start */}
                    <ScrollToTop />
                    {/* scrolltop-end */}
                </div>
            </div>

            <Footer />

        </div>
    );
}

export default CourseSidebar;